import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import { TableCompHead } from '../../../../components/ui';

interface IProps {
  moduleData: any;
  isView: boolean;
}

const THead = ({ moduleData, isView }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <thead>
      <TableCompHead
        colSpan={8}
        rowSpan={3}
        labels={['Doc No', 'Rev', 'Dated']}
        values={['F02 UNM 01', '00', '04.05.15']}
        heading="MACHINE  HISTORY CARD"
      />

      <tr>
        <th colSpan={3} align="left">
          Machine No.:
          {moduleData.machine_no}
        </th>
        <th colSpan={3} align="left">
          Machine Name:
          {moduleData.machine_name}
        </th>
        <th colSpan={3} align="left">
          Location:
          <TableInput
            name="location"
            type="text"
            value={moduleData.location}
            onChange={(e) => {
              moduleData.location = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr style={{ textTransform: 'uppercase' }}>
        {[
          'Date',
          'Type of Break Down',
          'Break down reporting Time',
          'Root cause',
          'Action Taken',
          'Sig.',
          'Remarks',
        ].map((head) => (
          <th
            style={{ textTransform: 'uppercase' }}
            colSpan={head === 'Remarks' ? 2 : 1}
          >
            {head}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
